const uploads = 'https://basmenninga.nl/wp-content/uploads'

export const contact = {
  email: 'bas.menninga@gmail.com',
  phone: '06 42 95 21 61',
  phoneHref: 'tel:+31642952161',
  location: 'Huizen',
  region: 'Het Gooi en omstreken',
}

export const navItems = [
  { label: 'Optreden', to: '/optreden' },
  { label: 'Muziekles', to: '/muziekles' },
  { label: 'Workshops', to: '/workshops' },
  { label: 'Repertoire', to: '/repertoire' },
  { label: 'Beeld', to: '/beeld' },
  { label: 'Over mij', to: '/over-mij' },
]

export const photos = {
  stage: `${uploads}/2024/08/2ac8a042-841f-421d-ab6e-cf7cc517bada.jpg`,
  guitarSmile: `${uploads}/2018/08/DSC_0283.jpg`,
  guitarPlaying: `${uploads}/2020/12/DSC_0276-scaled.jpg`,
  guitarGarden: `${uploads}/2020/12/DSC_0339-scaled.jpg`,
  portraitEvening: `${uploads}/2020/12/DSC_0158-scaled.jpg`,
  guitarFocus: `${uploads}/2022/03/DSC_0064-scaled.jpg`,
  piano: `${uploads}/2022/05/WhatsApp-Image-2022-05-03-at-12.36.24.jpeg`,
  ukulele: `${uploads}/2024/08/IMG_4173-1-scaled.jpg`,
  riverside: `${uploads}/2024/01/76f18273-93f8-43d9-8ae6-fa7e0570ba06.jpg`,
  street: `${uploads}/2024/08/IMG_3859-scaled.jpg`,
  ukePoster: `${uploads}/2025/05/Speel-de-Uke-1-724x1024.png`,
}
